import PropTypes from 'prop-types';
import StyledButtonMenuP from './StyledButtonMenuP';
import SpanPadLeft from '../Utils/spanpadleft';

const BotonMenuP = ({children, Titulo, accion}) => {
  return (
    <StyledButtonMenuP style={{borderBottom: "1px solid black"}} onClick={accion}>
      {children}
      <SpanPadLeft Title={Titulo}/>
    </StyledButtonMenuP>
  );
};

BotonMenuP.propTypes = {
  children: PropTypes.node,
  Titulo: PropTypes.string,
  accion: PropTypes.func
};

export default BotonMenuP;
